import {
  CreateFolderDocument,
  CreateFolderMutation,
  CreateFolderMutationVariables,
  FoldersDocument,
  FoldersSettingsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateFolder = () => {
  const [createFolderMutation, { loading }] = useMutation(CreateFolderDocument, {
    extractorFn: (data: CreateFolderMutation) => data.documentsMutations.createDocumentsFolder,
  })

  return {
    loading,
    createFolder(variables: CreateFolderMutationVariables) {
      return createFolderMutation({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [FoldersDocument, FoldersSettingsDocument],
      })
    },
  }
}
